/** Strings owned by the nav area. */
export const NAV_STRINGS = {
    // ── Sidebar / topnav (app.ts) ────────────────────────────────────────────
    'nav.my_devices': { en: 'My Devices', ru: 'Мои устройства' },
    'nav.farms': { en: 'Farms', ru: 'Фермы' },
    'nav.clicker': { en: 'Clicker', ru: 'Кликер' },
    'nav.flows': { en: 'Flows', ru: 'Флоу' },
    'nav.dashboards': { en: 'Dashboards', ru: 'Дашборды' },
    'nav.charts': { en: 'Charts', ru: 'Графики' },
    'nav.users': { en: 'Users', ru: 'Пользователи' },
    'nav.remote_adb': { en: 'Remote ADB', ru: 'Удалённый ADB' },
    'nav.sign_out': { en: 'Sign out', ru: 'Выход' },
    'nav.toggle_sidebar': { en: 'Toggle sidebar', ru: 'Свернуть/развернуть меню' },
    'nav.profile': { en: 'Profile', ru: 'Профиль' },
    // ── Farm filter bar (core/farm-list.ts) ──────────────────────────────────
    'nav.search_farms': { en: 'Search farms…', ru: 'Поиск ферм…' },
    'nav.filter_type': { en: 'Type', ru: 'Тип' },
    'nav.teams': { en: 'Teams', ru: 'Команды' },
    'nav.farm_category_regular': { en: 'Regular', ru: 'Обычная' },
    // ── Farm row badges (core/farm-row.ts) ───────────────────────────────────
    'nav.farm_last_health_check': { en: 'Last health check: {time}', ru: 'Последняя проверка: {time}' },
    'nav.farm_vmos': { en: 'VMOS farm', ru: 'VMOS-ферма' },
    'nav.farm_regular': { en: 'Regular farm', ru: 'Обычная ферма' },
    'nav.farm_aggregator': { en: 'Aggregator farm — remote phone clients', ru: 'Ферма-агрегатор — удалённые телефоны-клиенты' },
    'nav.farm_duo': { en: 'Duo farm — DuoPlus cloud phones', ru: 'Duo-ферма — облачные телефоны DuoPlus' },
    'nav.farm_geelark': { en: 'GeeLark farm — GeeLark cloud phones', ru: 'GeeLark-ферма — облачные телефоны GeeLark' },
    'nav.farm_adspower': { en: 'AdsPower farm — web deposit reader', ru: 'AdsPower-ферма — считыватель депозитов из веба' },
    'nav.farm_mercado_api': { en: 'Mercado API farm — deposits over the Mercado Pago API', ru: 'Mercado API-ферма — депозиты через API Mercado Pago' },
    'nav.farm_version_update': { en: 'Update available: v{latest} (running v{version})', ru: 'Доступно обновление: v{latest} (сейчас v{version})' },
    'nav.farm_version_latest': { en: 'Running v{version} (latest)', ru: 'Сейчас v{version} (последняя)' },
    // ── Farm locations (core/farm-locations.ts) ──────────────────────────────
    'nav.location_not_set': { en: 'Not set', ru: 'Не задана' },
    'nav.country_dz': { en: 'Algeria', ru: 'Алжир' },
    'nav.country_ar': { en: 'Argentina', ru: 'Аргентина' },
    'nav.country_au': { en: 'Australia', ru: 'Австралия' },
    'nav.country_in': { en: 'India', ru: 'Индия' },
    'nav.country_ru': { en: 'Russia', ru: 'Россия' },
    'nav.country_tr': { en: 'Turkey', ru: 'Турция' },
    'nav.country_ve': { en: 'Venezuela', ru: 'Венесуэла' },
    'nav.country_cm': { en: 'Cameroon', ru: 'Камерун' },
    'nav.country_eg': { en: 'Egypt', ru: 'Египет' },
    'nav.country_kz': { en: 'Kazakhstan', ru: 'Казахстан' },
    'nav.country_uz': { en: 'Uzbekistan', ru: 'Узбекистан' },
    // ── Compact relative age (core/format.ts) ────────────────────────────────
    'nav.age_seconds': { en: '{n}s', ru: '{n}с' },
    'nav.age_minutes': { en: '{n}m', ru: '{n}м' },
    'nav.age_hours': { en: '{n}h', ru: '{n}ч' },
    'nav.age_days': { en: '{n}d', ru: '{n}д' },
};
